import Coupon from '@/components/caisse/manage-bons/coupon'
import $ from 'jquery'
import PrescripteurSelection from './PrescripteurSelection.vue'
import prescripteursApi from '@/api/_prescripteurs'
import Api from '@/api/api'

export default {
    name: 'confirm-payment',
    components: {
        Coupon, PrescripteurSelection
    },
    props: {
        beforePayment: { type: Function, default: null },
        info_caissier: Object,
        user_id: Number,
        compte_id: Number,
        patient: Object,
        total_net_a_payer: Number,
        toggle_payment_state: Number,
        prestations: Array,
        consultation_data: Object,
        etat_paiement: String,
        depot_data: Object,
        info_assurance: Object,
        prestation_data: Object,
        sfe_data: Object,
        prix_apport_social: Number,
        divers_info: Object,
        is_pre_saved_bon: {
            type: Boolean,
            default: false
        },
        warning_prestations_exclues: {
            type: Array,
            default: () => []
        },
        split_toggler: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            validation_id: '',
            validation_payload: null,
            paiement_erreur: '',
            payment_settings: { methods: { cash: true }, enabled_operators: [] },
            payment_settings_error: '',
            payment_method: 'cash',
            payment_operator_id: '',
            payment_reference: '',
            payment_reference_error: false,
            pending_recorded: false,
            total_montant_du: 0,        // === total_net_a_payer
            coupon_remise: 0,
            coupon_pourcent: 0,
            base_remise: 0,

            is_part_payment: false,
            confirm_part_payment: true,
            toggle_net_amount_edition: false,
            toggle_reliquat_edition: false,
            net_paye_is_greater: false,
            deposit_is_less: false,

            is_confirm_payment: true,
            is_confirm_operation: false,
            filtered_services: [],
            tmp_prestations: [],
            toggle_coupon: 0,

            is_reliquat: true,
            can_apply_reliquat: false,
            espece_is_less: false,
            reliquat_is_greater: false,
            field_is_empty: false,

            paiement: {
                user_id: 0,
                patient_id: 0,
                prestation: "",
                montant_du: 0,
                montant_recu: 0,
                tmp_montant_recu: 0,
                reliquat: 0,
                reliquat_remis: 0,
                reste_a_payer: 0,
                montant_net_paye: 0,
                compte_id: 0,
                remise: 0,
                montant_net_a_payer: 0
            },
            save_loading: false,
            is_primary: true,
            coupon_authorization: {},
            prestations_exclues: [],
            prestations_non_exclues: [],
            demandes_autorisation: [],
            all_checked: true,
            cas_choisi: '',
            is_op_confirm: true,
            can_reset: false
        }
    },

    watch: {
        toggle_payment_state() {
            this.validation_id = this.nouvelleValidationId()
            this.validation_payload = null
            this.paiement_erreur = ''
            this.save_loading = false
            this.pending_recorded = false
            this.payment_method = 'cash'
            this.payment_operator_id = ''
            this.payment_reference = ''
            this.payment_reference_error = false
            this.payment_settings_error = ''
            this.loadPaymentSettings()
            this.coupon_remise = 0
            this.initPayment( this.total_net_a_payer, this.total_net_a_payer)
            this.paiement.montant_net_a_payer = this.total_net_a_payer

            if (!this.isObjectEmpty(this.consultation_data)) {
                // this.consultation_data.prix_vente = this.consultation_data.prix_vente - this.prix_apport_social
                this.base_remise = this.consultation_data.prix_vente
            } else {
                this.base_remise = this.total_net_a_payer
            }
            

            this.is_reliquat = true
            if (this.etat_paiement === 'differer') {
                this.is_reliquat = false
                this.paiement.reste_a_payer = this.total_net_a_payer
            } else {
                this.paiement.reste_a_payer = 0
            }

            this.deposit_is_less = false
            if (this.etat_paiement === 'depot') {
                this.checkDepositSolvency(this.total_net_a_payer)
            }

            if (this.has_two_currencies) {
                this.$store.dispatch('getConfigInfoClinique', 'currency').then(() => {
                    this.currency_info = this.$store.getters['info_currency']
                })
            }
        },

        split_toggler() {
            if (this.warning_prestations_exclues.length > 0) {
                this.can_reset = false
                this.splitPrestations()
            }
        }
    },

    computed: {
        isElectronicPayment() {
            return this.payment_method !== 'cash'
        },
        electronicPaymentAllowed() {
            return this.etat_paiement !== 'depot' && this.etat_paiement !== 'differer' &&
                (this.paying_bill_state === '' || Number(this.paying_bill_state) === 0) &&
                Number(this.paiement.montant_net_a_payer) > 0
        },
        paymentOptions() {
            const labels = { cash: 'Espèces', mobile_money: 'Mobile Money', cheque: 'Chèque', transfer: 'Virement' }
            return Object.keys(labels).filter(key => this.payment_settings.methods[key] &&
                (key === 'cash' || this.electronicPaymentAllowed)).map(key => ({ key, label: labels[key] }))
        },
        mobileOperators() {
            return (this.payment_settings.enabled_operators || []).filter(item => item.wallet_account)
        },
        paymentCurrencyCode() {
            const label = String(this.currency_info.principal_currency || '').toUpperCase().replace(/\s/g, '')
            if (label.includes('CDF')) return 'CDF'
            if (label.includes('USD')) return 'USD'
            if (label.includes('XOF') || label.includes('CFA')) return 'XOF'
            return ''
        },
        paymentReceivedCurrencyCode() {
            if (this.is_primary) return this.paymentCurrencyCode
            const label = String(this.currency_info.secondary_currency || '').toUpperCase().replace(/\s/g, '')
            if (label.includes('CDF')) return 'CDF'
            if (label.includes('USD')) return 'USD'
            if (label.includes('XOF') || label.includes('CFA')) return 'XOF'
            return ''
        },
        paying_bill_state() {
            return this.$store.getters['paying_bill_state']
        },

        selected_bon_id() {
            return this.$store.getters['selected_bon_id']
        }
    },

    mounted() {
        Array.prototype.groupBy = function (key) {
            return this
                .reduce((hash, obj) => {
                    if (obj[key] === undefined) return hash;
                    return Object.assign(hash, { [obj[key]]: (hash[obj[key]] || []).concat(obj) })
                }, {})
        };
    },

    methods: {
        async loadPaymentSettings() {
            try {
                const response = await Api.clinique().get('/parametres/paiements/moyens')
                const settings = response.data
                if (!settings || !settings.methods || !Array.isArray(settings.enabled_operators)) throw new Error('configuration')
                this.payment_settings = settings
                if (!this.paymentOptions.some(option => option.key === this.payment_method)) {
                    this.selectPaymentMethod(this.paymentOptions.length ? this.paymentOptions[0].key : '')
                }
            } catch (_) {
                // L'encaissement en espèces historique reste disponible si Clinique est temporairement inaccessible.
                this.payment_settings = { methods: { cash: true }, enabled_operators: [] }
                this.payment_settings_error = 'Les autres moyens de paiement sont momentanément indisponibles.'
            }
        },
        selectPaymentMethod(method) {
            if (this.save_loading || this.validation_payload) return
            this.payment_method = method
            this.payment_operator_id = ''
            this.payment_reference = ''
            this.payment_reference_error = false
            this.paiement_erreur = ''
            this.is_part_payment = false
            if (method && method !== 'cash') {
                const amount = Number(this.paiement.montant_net_a_payer)
                this.paiement.tmp_montant_recu = amount
                this.paiement.montant_recu = amount
                this.paiement.montant_net_paye = amount
                this.paiement.reliquat = 0
                this.paiement.reliquat_remis = 0
                this.paiement.reste_a_payer = 0
                this.is_primary = true
            } else if (method === 'cash') {
                this.paiement.tmp_montant_recu = 0
                this.paiement.montant_recu = 0
                this.paiement.montant_net_paye = 0
                this.paiement.reliquat = 0
                this.paiement.reliquat_remis = 0
            }
        },
        validatePaymentMethod() {
            this.payment_reference_error = false
            if (this.etat_paiement === 'depot' || this.etat_paiement === 'differer') return ''
            if (!this.payment_method) return 'Aucun moyen de paiement actif pour ce règlement.'
            if (!this.paymentOptions.some(option => option.key === this.payment_method)) return 'Ce moyen n’est plus disponible.'
            if (this.payment_method === 'cash') {
                return this.paymentCurrencyCode && this.paymentReceivedCurrencyCode
                    ? '' : 'La devise reçue pour ce paiement en espèces n’est pas reconnue.'
            }
            if (!this.electronicPaymentAllowed) return 'Ce moyen exige un règlement complet, sans dépôt ni paiement différé.'
            if (!this.paymentCurrencyCode) return 'La devise de ce paiement n’est pas reconnue.'
            if (this.payment_method === 'mobile_money' && !this.mobileOperators.some(item => item.id === this.payment_operator_id)) {
                return 'Choisissez un opérateur Mobile Money avec un portefeuille du centre.'
            }
            if (!this.payment_reference.trim()) {
                this.payment_reference_error = true
                return this.payment_method === 'mobile_money'
                    ? 'Saisissez le numéro de transaction Mobile Money.' : 'Saisissez la référence bancaire.'
            }
            return ''
        },
        nouvelleValidationId() {
            const bytes = new Uint8Array(16)
            window.crypto.getRandomValues(bytes)
            bytes[6] = (bytes[6] & 15) | 64; bytes[8] = (bytes[8] & 63) | 128
            const hex = Array.from(bytes, b => b.toString(16).padStart(2, '0')).join('')
            return [hex.slice(0, 8), hex.slice(8, 12), hex.slice(12, 16), hex.slice(16, 20), hex.slice(20)].join('-')
        },
        /**
         * verify solvency by payment on deposit
         * @param {*} montant_du 
         */
        checkDepositSolvency(montant_du) {
            const solde_disponible = (this.depot_data.a_depense == 0)?this.depot_data.montant:this.depot_data.montant_restant

            this.paiement.montant_recu = montant_du

            this.deposit_is_less = false
            if (solde_disponible < montant_du) {
                this.deposit_is_less = true
            }
        },

        toggleEdtion(state) {
            if (state === 'reliquat') {
                this.toggle_reliquat_edition = !this.toggle_reliquat_edition
            } else {
                this.toggle_net_amount_edition = !this.toggle_net_amount_edition
            }
        },

        calcReliquat() {
            this.clearError()
            const amount_is_empty = this.validateStringNotEmpty(this.paiement.tmp_montant_recu)
            if (amount_is_empty) {
                this.paiement.montant_net_paye = 0
                return
            }
            this.paiement.tmp_montant_recu = this.cleanNumber(this.paiement.tmp_montant_recu)

            if (!this.is_primary) {
                this.paiement.montant_recu = this.paiement.tmp_montant_recu * this.currency_info.rate
            } else {
                this.paiement.montant_recu = this.paiement.tmp_montant_recu
            }

            if (this.paiement.montant_recu > 0) {
                if (this.paiement.montant_recu > this.total_montant_du) {
                    this.paiement.reliquat_remis = this.paiement.montant_recu - this.total_montant_du
                    // this.paiement.reste_a_payer = 0
                } else {
                    this.paiement.reliquat = 0
                    this.paiement.reliquat_remis = 0
                    // this.paiement.reste_a_payer = this.total_montant_du - this.paiement.montant_recu
                }
                this.paiement.montant_net_paye = this.paiement.montant_recu
            } else {
                this.paiement.reliquat = 0
                this.paiement.reliquat_remis = 0
            }
            this.espece_is_less = false
            this.reliquat_is_greater = false
            this.field_is_empty = false
            
        },

        postponeReliquat() {
            if (this.paiement.reliquat_remis >= this.paiement.montant_recu) {
                this.reliquat_is_greater = true
                return
            }
            this.paiement.reliquat = this.paiement.reliquat_remis
            this.paiement.reliquat_remis = 0
        },

        onConfirm() {
            this.confirm_part_payment = true
            this.is_confirm_payment = true
        },

        checkIfAmountCanBeZero() {
            let can_be_zero = false

            if (this.info_assurance.est_assure) {
                can_be_zero = (this.total_net_a_payer == 0)?true:false
            } else {
                if (this.coupon_remise == this.total_net_a_payer) {
                    can_be_zero = true
                }
            }
            return can_be_zero
        },

        nextToConfirm(v, part_selector) {
            this.clearError()
            this.paiement.reste_a_payer = 0

            const methodError = this.validatePaymentMethod()
            if (methodError) {
                this.paiement_erreur = methodError
                return
            }
            if (this.isElectronicPayment) {
                const amount = Number(this.paiement.montant_net_a_payer)
                this.paiement.montant_recu = amount
                this.paiement.montant_net_paye = amount
                this.paiement.reliquat = 0
                this.paiement.reliquat_remis = 0
                this.setPrestation()
                this.is_reliquat = false
                return
            }

            const amount_is_empty = this.validateStringNotEmpty(this.paiement.montant_recu)
            if (amount_is_empty) {
                this.field_is_empty = true
                return;
            }
            this.paiement.montant_recu = this.cleanNumber(this.paiement.montant_recu)

            const can_be_zero = this.checkIfAmountCanBeZero()
            if (!can_be_zero && this.paiement.montant_recu == 0) {
                this.field_is_empty = true
                return;
            }

            if (this.paiement.montant_net_paye > this.paiement.montant_recu) {
                this.net_paye_is_greater = true
                return;
            }

            // TODO
            if (!can_be_zero) {
                if (this.paiement.reliquat_remis >= this.paiement.montant_recu) {
                    this.reliquat_is_greater = true
                    return;
                }
    
                if ((this.paiement.montant_recu < this.total_montant_du) || (this.paiement.montant_net_paye < this.total_montant_du)) {
                    this.is_part_payment = true
                }
            }
            

            const part_confirm = document.getElementById(part_selector);
            if (this.is_part_payment && !part_confirm) {
                return;
            }

            if (this.is_part_payment && !part_confirm.checked) {
                this.confirm_part_payment = false
                return;
            }

            this.setPrestation()
            if (this.is_part_payment && part_confirm.checked) {
                let reste = 0
                
                this.filtered_services.forEach(service => {
                    if (service.data_type != 'apport_social') {
                        if (this.paying_bill_state == 3) {
                            reste += service.montant_restant - service.net_paye
                        } else {
                            reste += (service.prix_vente - service.net_paye)
                        }
                        
                        this.paiement.reste_a_payer = reste
                    }
                });
            }
            this.is_reliquat = !v
            // this.can_apply_reliquat = v
        },

        setPrestation() {
            this.tmp_prestations = []

            if (this.paying_bill_state != 2) {      // Different du cas différé
                this.sortPrestation()
            }

            this.prestations.forEach(prestation => {
                const tmp_prestation = {
                    uid: (this.paying_bill_state !== '')?prestation.uid:'',
                    data_type: prestation.data_type,
                    parent_id: prestation.parent_id,
                    parent_libelle: (prestation.parent_libelle)?prestation.parent_libelle:null,
                    id: prestation.id,
                    operation_id: prestation.operation_id,
                    libelle: prestation.libelle,
                    code_assurance_prod: (prestation.code_assurance_prod)?prestation.code_assurance_prod:"",
                    nom_acte: prestation.nom_acte,
                    prix: prestation.prix,
                    prix_clinique: prestation.prix_clinique,
                    prix_vente: prestation.prix_vente,
                    group_taxation: prestation.group_taxation,
                    taxe_specifique: prestation.taxe_specifique,
                    net_paye: prestation.net_paye,
                    prix_assure_clinique: prestation.prix_assure_clinique,
                    base_assurance: prestation.base_assurance,
                    part_assureur: prestation.part_assureur,
                    taux_couverture: prestation.taux_couverture,
                    coupon_remise: prestation.coupon_remise,
                    qte: prestation.qte,
                    est_exclu: prestation.est_exclu,
                    is_vente_caisse: prestation.is_vente_caisse,
                    montant_restant: prestation.montant_restant,
                    is_facture_compl: prestation.is_facture_compl,
                    type_facturation: prestation.type_facturation
                }
                this.tmp_prestations.push(tmp_prestation)
            });
            
            if (!this.isObjectEmpty(this.consultation_data)) {
                this.tmp_prestations.unshift(this.consultation_data)
            }

            
            if (this.etat_paiement === 'differer') {
                this.filtered_services = []

                this.tmp_prestations.forEach((prestation, index) => {
                    if (prestation.libelle === 'Apport social') {
                        this.tmp_prestations[index]['data_type'] = 'apport_social'
                    }
                });

                this.filtered_services = this.tmp_prestations
                return
            }

            this.filterPrestation()
            
        },

        /**
         * Sort list of services by descending order
         */
        sortPrestation() {
            if (this.paying_bill_state!=3) {
                this.prestations.sort( (a, b) => a.prix_vente - b.prix_vente )
            } else {
                this.prestations.sort( (a, b) => a.montant_restant - b.montant_restant )
            }
            
        },

        /**
         * Verifier s'il ya Apport social
         */
        checkApportSocial() {
            let apport_social = 0
            this.tmp_prestations.forEach((prestation, index) => {
                if (prestation.libelle === 'Apport social' || prestation.data_type == 'apport_social') {
                    this.tmp_prestations[index]['data_type'] = 'apport_social'
                    apport_social = prestation.prix_clinique
                }
            });
            return apport_social
        },

        /** 
         * Filter list of services accordingly to the paid ones
        */
        filterPrestation() {
            const apport_social = this.checkApportSocial()

            this.filtered_services = []
            let mnt_paye = this.paiement.montant_net_paye
            
            if (apport_social > 0) {
                mnt_paye += apport_social
            }
            
            this.tmp_prestations.forEach((prestation, index) => {
                if (mnt_paye > 0 || (this.coupon_pourcent == 100 && this.paiement.montant_net_paye == 0)  || this.total_net_a_payer == 0) {
                    
                    let nv_prix_vente = (this.paying_bill_state!=3)?prestation.prix_vente:prestation.montant_restant
                    if ((mnt_paye > nv_prix_vente) || (mnt_paye == 0 && this.total_net_a_payer == 0)) {
                        if (prestation.data_type != 'apport_social') {
                            this.tmp_prestations[index]['net_paye'] = nv_prix_vente
                            // mnt_paye = mnt_paye - (prestation.prix_clinique * prestation.qte)
                            
                            mnt_paye = mnt_paye - nv_prix_vente
                        }
                    } else {
                        this.tmp_prestations[index]['net_paye'] = mnt_paye
                        mnt_paye = 0
                    }
                    this.filtered_services = [...this.filtered_services, this.tmp_prestations[index]]
                } 
                else {
                    // if (mnt_paye == 0 && prestation.data_type == 'apport_social') {
                        this.filtered_services = [...this.filtered_services, this.tmp_prestations[index]]
                    // }
                    // this.filtered_services = [...this.filtered_services, this.tmp_prestations[index]]
                    
                    // const can_be_zero = this.checkIfAmountCanBeZero()
                    // // if (can_be_zero && mnt_paye == 0) {
                    // //     this.filtered_services = [...this.filtered_services, this.tmp_prestations[index]]
                    // // }
                }
            });
            
        },

        setPrestationUid() {
            if (!this.validation_id) this.validation_id = this.nouvelleValidationId()
            this.filtered_services.forEach((prestation, index) => {

                if (this.paying_bill_state !== '') {
                    this.filtered_services[index]['uid'] = prestation.uid
                    return;
                } 

                this.filtered_services[index]['uid'] = 'paiement-' + this.validation_id + '-' + index
            });
        },

        groupPrestatation(prestations) {
            const tmp_grouped_operations = prestations.groupBy('data_type')
            let grouped_operations = []
          
            let taux_couverture = (this.paiement.info_assurance.est_assure == 1)?this.paiement.info_assurance.taux_couverture:''
            
            for (const key in tmp_grouped_operations) {
                if (key == 'consommable_bon' || key == 'apport_social') {
                    taux_couverture = ''
                }
                const tmp_group = {
                    data_type: key,
                    taux_couverture: (taux_couverture == '')?tmp_grouped_operations[key][0]['taux_couverture']:taux_couverture,
                    libelle: this.setLibellePrestation(key),
                    prestations: tmp_grouped_operations[key]
                }
                grouped_operations.push(tmp_group)
            }

            this.paiement.remise = 0
            grouped_operations.forEach((group, index) => {
                let total_prix_by_group = 0
                let total_base_assurance_by_group = 0
                let total_pac_by_group = 0
                let total_part_assureur_by_group = 0
                let total_net_paye_by_group = 0
                let total_remise_by_group = 0
                let total_prix_vente_by_group = 0
                let group_taxe_specifique = 0
                group.prestations.forEach((prestation, p_index) => {
                    group.prestations[p_index].groupe_taxation = ''
                    if (prestation.group_taxation && Object.prototype.hasOwnProperty.call(prestation.group_taxation, 'slug')) {
                        group.prestations[p_index].groupe_taxation = this.capitalizeFirstLetter(prestation.group_taxation.slug)
                    }
                    
                    let qte = 0
                    qte = prestation.qte

                    let pu = 0
                    if (this.can_set_pac && this.paiement.info_assurance.est_assure && prestation.data_type != 'consommable_bon') {
                        pu = prestation.prix_assure_clinique
                    } else {
                        pu = (prestation.prix_clinique > prestation.base_assurance)?prestation.prix_clinique:prestation.base_assurance
                    }
                    
                    total_prix_by_group += (pu * qte)

                    total_net_paye_by_group += prestation.net_paye

                    if (prestation.coupon_remise) {
                        total_remise_by_group += prestation.coupon_remise
                    }
                    
                    total_prix_vente_by_group += (prestation.data_type != 'apport_social')?prestation.prix_vente:(-prestation.prix_vente)
                    group_taxe_specifique += prestation.taxe_specifique

                    if (this.paiement.info_assurance.est_assure == 1) {
                        if (prestation.base_assurance > 0) {
                            total_base_assurance_by_group += (parseInt(prestation.base_assurance) * qte)
                        }

                        if (prestation.prix_assure_clinique > 0) {
                            total_pac_by_group += ( parseInt(prestation.prix_assure_clinique) * prestation.qte)
                        }
                        
                        total_part_assureur_by_group += prestation.part_assureur
                    }
                });
                grouped_operations[index].total_prix_by_group = total_prix_by_group
                grouped_operations[index].total_net_paye_by_group = total_net_paye_by_group
                grouped_operations[index].total_remise_by_group = total_remise_by_group
                grouped_operations[index].total_base_assurance_by_group = total_base_assurance_by_group
                grouped_operations[index].total_pac_by_group = total_pac_by_group
                grouped_operations[index].total_part_assureur_by_group = total_part_assureur_by_group
                grouped_operations[index].total_prix_vente_by_group = total_prix_vente_by_group
                grouped_operations[index].group_taxe_specifique = group_taxe_specifique

                this.paiement.remise += total_remise_by_group
            });
            

            return grouped_operations
        },

        async handlePayment(selector) {
            if (this.save_loading) return
            const methodError = this.validatePaymentMethod()
            if (methodError) { this.paiement_erreur = methodError; return }
            const initial = this.paying_bill_state === '' || Number(this.paying_bill_state) === 0
            if (initial && (!this.$refs.prescripteur || !this.$refs.prescripteur.valider())) return
            this.paiement_erreur = ''
            const confirm = document.getElementById(selector);
            if (!confirm.checked) {
                this.is_confirm_payment = false
                return
            }

            if (this.beforePayment) {
                this.save_loading = true
                try {
                    if (!await this.beforePayment()) {
                        this.save_loading = false
                        this.warningToast('Le médecin choisi ne peut pas être validé. Fermez cette fenêtre et choisissez un médecin éligible ou Non attribué.')
                        return
                    }
                } catch (error) {
                    this.save_loading = false
                    this.warningToast('Impossible de vérifier le médecin. Aucun paiement envoyé. Réessayez.')
                    return
                }
            }

            if (this.etat_paiement === 'differer') {
                this.setPrestation()
            }

            this.setPrestationUid()

            this.filtered_services.forEach((service, index) => {
                if (service.data_type == 'apport_social') {
                    this.filtered_services[index].libelle += " - "+this.consultation_data.libelle
                }
            });

            let info_patient = {
                nom_patient: this.patient.nom_patient,
                sexe: this.patient.sexe,
                telephone: this.patient.telephone_mobile,
                num_dossier: this.patient.num_dossier,
                age: this.patient.age
            }

            
            
            this.paiement.info_caissier = this.info_caissier
            this.paiement.info_patient = info_patient
            this.paiement.prestation = this.prestation_data.libelle
            this.paiement.montant_du = this.total_montant_du
            this.paiement.total_du = this.total_net_a_payer
            if (this.payment_method !== 'cash') {
                this.paiement.total_du = Number(this.paiement.montant_net_a_payer)
                this.paiement.payment_request_id = this.validation_id
                this.paiement.payment_currency = this.paymentCurrencyCode
                this.paiement.payment_reference = this.payment_reference.trim()
                this.paiement.payment_operator_id = this.payment_method === 'mobile_money' ? this.payment_operator_id : null
            }
            if (this.etat_paiement !== 'depot' && this.etat_paiement !== 'differer') {
                this.paiement.payment_method = this.payment_method
                if (this.paymentCurrencyCode) this.paiement.payment_currency = this.paymentCurrencyCode
                delete this.paiement.payment_received_currency
                if (this.payment_method === 'cash' && this.paymentReceivedCurrencyCode) {
                    this.paiement.payment_received_currency = this.paymentReceivedCurrencyCode
                }
            }
            this.paiement.user_id = this.user_id
            this.paiement.patient_id = this.patient.id
            this.paiement.compte_id = this.compte_id
            this.paiement.prestations = this.filtered_services
            this.paiement.info_assurance = this.info_assurance
            this.paiement.type_operation = 1        // Recette
            this.paiement.etat_paiement = this.etat_paiement
            this.paiement.paying_bill_state = this.isElectronicPayment ? 0 : this.paying_bill_state
            this.paiement.is_with_deposit = (!this.isObjectEmpty(this.depot_data))
            this.paiement.depot_data = this.depot_data
            this.paiement.sfe_aib = this.sfe_data.info_aib.slug
            this.paiement.sfe_libelle_aib = this.sfe_data.info_aib.libelle
            this.paiement.sfe_impot_aib = this.sfe_data.impot_aib
            this.paiement.remise_percentage = parseFloat(this.coupon_pourcent).toFixed(2)
            this.paiement.info_currency = this.currency_info
            this.paiement.coupon_authorization = this.coupon_authorization
            this.paiement.is_pre_saved_bon = this.is_pre_saved_bon
            this.paiement.selected_bon_id = this.selected_bon_id
            this.paiement.is_demande_autorisation = (this.cas_choisi == 'avec_demande')?1:0
            this.paiement.demandes_autorisation = (this.cas_choisi == 'avec_demande')?this.demandes_autorisation:[]

            this.save_loading = true

            const grouped_prestations = this.groupPrestatation(this.paiement.prestations)    
            
            if (initial && !this.validation_payload) {
                this.validation_payload = JSON.parse(JSON.stringify(Object.assign({}, this.paiement,
                    this.$refs.prescripteur.selection(), { requete_id: this.validation_id })))
            }
            const validation = initial ? prescripteursApi.payer(this.validation_payload) : this.$store.dispatch('updateOperationCaisse', this.paiement)
            return validation.then((response) => {
                if (response.success) {
                    if (response.data && response.data.payment_status === 'pending') {
                        this.pending_recorded = true
                        this.paiement_erreur = ''
                        this.save_loading = false
                        return
                    }
                    if (initial) this.paiement = JSON.parse(JSON.stringify(this.validation_payload))
                    if (initial) {
                        // Carry the server receipt into direct vouchers and pending analyses/exams.
                        // Never alter validation_payload: it is the immutable payment retry key.
                        this.paiement.prestations = this.paiement.prestations.map(prestation => Object.assign({}, prestation, {
                            prescription_caisse: ['analyse', 'examen'].includes(prestation.data_type) ? (response.prescription_caisse || null) : null
                        }))
                    }
                    this.paiement.grouped_prestations = initial ? this.groupPrestatation(this.paiement.prestations) : grouped_prestations

                    if (this.prestation_data.data_type == 'bon_consultation') {
                        let consultation_info = {}
                        this.paiement.prestations.forEach((prestation) => {
                            if (prestation.data_type === 'bon_consultation') {
                                consultation_info = prestation
                            }
                        });

                        const data = {
                            data_type: this.prestation_data.data_type,
                            etat_paiement: this.etat_paiement,
                            consultation_info: consultation_info,
                            paiement: this.paiement, 
                            ticket_info: response.data,
                            payment_replayed: response.payment_replayed === true
                        }

                        this.$emit('emitBonConsultation', data)
                    } else if (this.prestation_data.data_type == 'analyse' || this.prestation_data.data_type == 'examen') {
                        const data = {
                            data_type: this.prestation_data.data_type,
                            etat_paiement: this.etat_paiement,
                            prestations: this.paiement.prestations,
                            paiement: this.paiement, 
                            ticket_info: response.data
                        }
                        this.$emit('emitBonMedical', data)
                    } else if (this.prestation_data.data_type == 'pharmacie' || this.prestation_data.data_type == 'acte') {
                        const data = {
                            data_type: this.prestation_data.data_type,
                            etat_paiement: this.etat_paiement,
                            prestations: this.paiement.prestations,
                            paiement: this.paiement, 
                            ticket_info: response.data
                        }
                        this.$emit('emitVente', data)
                    } else if (this.prestation_data.data_type == '') {
                        const data = {
                            data_type: this.prestation_data.data_type,
                            etat_paiement: this.etat_paiement,
                            prestations: this.paiement.prestations,
                            paiement: this.paiement, 
                            ticket_info: response.data
                        }
                        this.$emit('emitUpdate', data)
                    }
                    
                    this.$refs.cfrm_payment.click()
                } else {
                    this.paiement_erreur = 'Le paiement n’a pas été validé. Vérifiez les informations puis réessayez.'
                    this.validation_payload = null
                }
                this.save_loading = false
            }).catch(error => {
                const result = error.response && error.response.data
                this.paiement_erreur = result && result.message ? result.message : 'Réponse du serveur indisponible. Réessayez sans fermer cette fenêtre : la même validation sera reprise.'
                if (error.response && [401, 403, 422].includes(error.response.status)) this.validation_payload = null
                this.save_loading = false
            })
        },

        backToPayment() {
            this.is_reliquat = true
        },

        clearError() {
            this.is_part_payment = false
            this.net_paye_is_greater = false
            this.reliquat_is_greater = false
        },

        goToCoupon() {
            this.toggle_coupon = (this.toggle_coupon == 0)?1:0

            this.initPayment(this.total_net_a_payer, this.total_net_a_payer)
        },

        applyCoupon(coupon_data) {
            this.coupon_authorization = {
                nom: (coupon_data.coupon_user_authorizer && coupon_data.coupon_user_authorizer.name)?coupon_data.coupon_user_authorizer.name:'',
                titre: (coupon_data.coupon_user_authorizer && coupon_data.coupon_user_authorizer.titre)?coupon_data.coupon_user_authorizer.titre:'',
                comment: coupon_data.coupon_comment
            }
            
            let montant_du_remise = 0
            this.coupon_pourcent = coupon_data.coupon_pourcent
            
            if (!this.isObjectEmpty(this.consultation_data)) {
                // Update Prix de vente consultation
                this.consultation_data.prix_vente = this.consultation_data.prix_clinique - coupon_data.remise
                this.consultation_data.coupon_remise = coupon_data.remise

                this.prestations.forEach(prestation => {
                    if (prestation.libelle != 'Apport social') {
                        montant_du_remise += prestation.prix_vente
                    } else {
                        montant_du_remise -= prestation.prix_vente
                    }
                });
                montant_du_remise += coupon_data.montant_du
            } else {
                
                this.sortPrestation()
                let montant_remise = coupon_data.remise

                this.prestations.forEach((prestation, index) => {

                    let valeur_ajoutee = 0
                    if (prestation.taxe_specifique > 0) {
                        valeur_ajoutee = parseFloat( prestation.taxe_specifique * (1 + (prestation.group_taxation.taux / 100)) ).toFixed(0)
                        valeur_ajoutee = parseInt(valeur_ajoutee)
                    }

                    if (montant_remise > 0) {
                        if (montant_remise >= (prestation.prix_clinique * prestation.qte)) {
                            this.prestations[index]['coupon_remise'] = prestation.prix_clinique * prestation.qte
                            montant_remise -= (prestation.prix_clinique * prestation.qte)
                        } else {
                            this.prestations[index]['coupon_remise'] = montant_remise
                            montant_remise = 0
                        }
                        this.prestations[index]['prix_vente'] = ((prestation.prix_clinique * prestation.qte) - this.prestations[index]['coupon_remise']) + valeur_ajoutee
                    } else {
                        this.prestations[index]['prix_vente'] = (prestation.prix_clinique * prestation.qte) + valeur_ajoutee
                    }
                    

                    // this.prestations[index]['coupon_remise'] = Math.floor((coupon_data.coupon_pourcent * prestation.prix_clinique) / 100) * prestation.qte
                    
                    // const remise_by_prestation = Math.ceil(( ((100 - coupon_data.coupon_pourcent) / 100) * prestation.prix_clinique ) * prestation.qte) + valeur_ajoutee
                    
                    
                    // this.prestations[index]['prix_vente'] = remise_by_prestation
                });

                montant_du_remise = coupon_data.montant_du
                this.paiement.montant_net_a_payer = coupon_data.montant_du
            }
            
            this.initPayment(montant_du_remise, coupon_data.montant_du)
            this.coupon_remise = coupon_data.remise

            // If payment is by deposit, then check back the solvency
            if (this.etat_paiement == 'depot') {
                this.checkDepositSolvency(montant_du_remise)
            }
        },

        initPayment(montant_du, montant_a_payer) {
            this.paiement = {
                user_id: 0,
                patient_id: 0,
                prestation: "",
                montant_du: 0,
                montant_recu: 0,
                tmp_montant_recu: 0,
                reliquat: 0,
                reliquat_remis: 0,
                reste_a_payer: 0,
                montant_net_paye: 0,
                montant_net_a_payer: 0,
                compte_id: 0,
                remise: 0
            }
            
            if (this.etat_paiement !== 'differer') {
                this.paiement.montant_net_a_payer = montant_a_payer

                if (this.etat_paiement === 'depot') {
                    // if (!this.deposit_is_less) {
                        this.paiement.montant_net_paye = montant_a_payer
                    // }
                }
                
            }
            
            this.total_montant_du = montant_du
        },

        toggleCurrency() {
            this.is_primary = (this.is_primary)?false:true
            this.paiement = {
                user_id: 0,
                patient_id: 0,
                prestation: "",
                montant_du: 0,
                montant_recu: 0,
                tmp_montant_recu: 0,
                reliquat: 0,
                reliquat_remis: 0,
                reste_a_payer: 0,
                montant_net_paye: this.total_net_a_payer,
                montant_net_a_payer: this.paiement.montant_net_a_payer,
                compte_id: 0,
                remise: 0,
            }
        },

        splitPrestations() {
            this.prestations_exclues = this.prestations.filter(el => el.est_exclu === 1)
            this.prestations_non_exclues = this.prestations.filter(el => el.est_exclu === 0)

            setTimeout(() => {
                this.checkAll()
            }, 200);
        },

        checkAll() {
            this.is_confirm_operation = false
            this.can_reset = false
            this.demandes_autorisation = [] 
            let is_checked = $('#check-exclues').is(":checked")
            console.log("is_checked : ",is_checked);
            
            if (is_checked) {
                this.prestations_exclues.forEach(el => {
                    this.demandes_autorisation.push(el)
                });
                this.all_checked = true
            } 
            else {
                this.demandes_autorisation = []  
                this.all_checked = false

                this.prestations_exclues.forEach(el => {
                    this.prestations_non_exclues.push(el)
                });

                setTimeout(() => {
                   this.prestations_exclues = [] 
                }, 100);
                
            }
        },

        onOneChange(prestation, index) {
            this.is_confirm_operation = false
            this.can_reset = false
            let c = $('#ops-'+prestation.operation_id).is(":checked")
            if (!c) {
                this.prestations_non_exclues.push(prestation)

                setTimeout(() => {
                    this.prestations_exclues.splice(index, 1)
                }, 100);
            }
        },

        addToExclue(prestation, index) {
            this.prestations_exclues.push(prestation)
            this.prestations_non_exclues.splice(index, 1)

            setTimeout(() => {
                this.demandes_autorisation.push(prestation)
            }, 1000);
        },

        nextToSaveOperation() {
            this.$refs.cfrm_soc_op.click()

            setTimeout(() => {
                $('.cfrm-payment').modal('show')
            }, 100);
        },

        checkIfCanResetOpeartionToPay(cas_op) {
            this.cas_choisi = cas_op
            if (!this.is_confirm_operation) {
                this.is_confirm_operation = true
            }

            this.can_reset = true
        },

        resetOperationToPay(selector) {
            const confirm = document.getElementById(selector);
            if (!confirm.checked) {
                this.is_op_confirm = false
                return
            }

            this.save_loading = true
            this.$refs.cfrm_soc_op.click()
            this.$emit('emitResetOperationToPay', this.prestations_non_exclues)
        },

        onConfirmOP() {
            this.is_op_confirm = true
        },

        scrollTo(anchor) {
            setTimeout(() => {
                let scroll_value = $('#'+anchor).offset().top
                $('#scrl-aut-anchor').animate({
                    scrollTop: scroll_value
                }, 800, function() {});
            }, 1000);
        },
    }
}


